import bcrypt from "bcryptjs";

const API_URL = "http://localhost:3001/api"; // Ändra till din backendadress vid produktion

// Hämta användare från localStorage
export function getUsers() {
  const users = JSON.parse(localStorage.getItem("users")) || [];
  return users;
}

// Spara användare till localStorage
function saveUsers(users) {
  localStorage.setItem("users", JSON.stringify(users));
}

// Skapa ny användare
export async function createUser(username, password, role, namn, pin) {
  const users = getUsers();
  if (users.some(u => u.username === username)) {
    throw new Error("Användarnamnet är redan upptaget");
  }
  const id = Date.now();
  const passwordHash = await bcrypt.hash(password, 12);
  const pinHash = pin ? await bcrypt.hash(pin, 12) : "";
  users.push({ id, username, namn, passwordHash, resetPinHash: pinHash, failedResetAttempts: 0, locked: false, role });
  saveUsers(users);

  await logEvent("success", `Admin skapade ny användare: ${username}`);
}

// Validera inloggning
export async function validateLogin(username, password) {
  const users = getUsers();
  const user = users.find(u => u.username === username);
  if (!user) return null;
  if (user.locked) return null;

  const match = await bcrypt.compare(password, user.passwordHash);
  if (!match) return null;
  return user;
}

// Uppdatera lösenord
export async function updatePassword(id, newPassword) {
  const users = getUsers();
  const idx = users.findIndex(u => u.id === id);
  if (idx === -1) throw new Error("Användare hittades inte");

  users[idx].passwordHash = await bcrypt.hash(newPassword, 12);
  saveUsers(users);

  await logEvent("success", `Lösenord uppdaterades för användare: ${users[idx].username}`);
}

// Uppdatera användare (namn, roll)
export async function updateUser(id, updates) {
  const users = getUsers();
  const idx = users.findIndex(u => u.id === id);
  if (idx === -1) throw new Error("Användare hittades inte");

  users[idx] = { ...users[idx], ...updates };
  saveUsers(users);

  await logEvent("info", `Admin uppdaterade användare: ${users[idx].username}`);
}

// Byt pinkod
export async function changePin(id, newPin) {
  const users = getUsers();
  const idx = users.findIndex(u => u.id === id);
  if (idx === -1) throw new Error("Användare hittades inte");

  users[idx].resetPinHash = await bcrypt.hash(newPin, 12);
  saveUsers(users);

  await logEvent("success", `Pinkod uppdaterades för användare: ${users[idx].username}`);
}

// Ta bort användare
export async function deleteUser(id) {
  const users = getUsers();
  const idx = users.findIndex(u => u.id === id);
  if (idx === -1) throw new Error("Användare hittades inte");

  const deletedUser = users[idx].username;
  users.splice(idx, 1);
  saveUsers(users);

  await logEvent("error", `Användare raderades: ${deletedUser}`);
}

// Lås upp användare
export async function unlockUser(id) {
  const users = getUsers();
  const idx = users.findIndex(u => u.id === id);
  if (idx === -1) throw new Error("Användare hittades inte");

  users[idx].locked = false;
  users[idx].failedResetAttempts = 0;
  saveUsers(users);

  await logEvent("info", `Admin låste upp användare: ${users[idx].username}`);
}

// Logga händelser till backend
export async function logEvent(type, message) {
  try {
    await fetch(`${API_URL}/log-event`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ type, message })
    });
  } catch (err) {
    console.error("Kunde inte logga händelsen:", err);
  }
}

// Hämta loggar från backend
export async function getLogs() {
  try {
    const res = await fetch(`${API_URL}/logs`);
    if (!res.ok) throw new Error("Kunde inte hämta loggar");
    return await res.json();
  } catch (err) {
    console.error(err);
    return [];
  }
}

export async function validatePin(username, pin) {
  const users = getUsers();
  const user = users.find(u => u.username === username);
  if (!user) return false;

  if (!user.resetPinHash) return false;
  return await bcrypt.compare(pin, user.resetPinHash);
}
